import React from 'react';
import { connect, ConnectedProps } from 'react-redux';

import { RootState } from './reducers';

import Main from 'Containers/Main';

const mapState = ({ nav: { location }, user }: RootState) => {
  return {
    path: location,
    user: user,
  };
};

const connector = connect(mapState);

type Props = ConnectedProps<typeof connector> & {
  /* prop types here */
};

const App: React.FC<React.PropsWithChildren<Props>> = () => {
  return <Main />;
};

export default connector(App);
